export default __webpack_public_path__ + "static/media/reviews.896b6f14.svg";